import { IonPopover, IonList, IonItem, IonItemGroup, IonButton, IonAlert, IonicSafeString } from "@ionic/react";
import React, { useState } from "react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onReportProblem?: () => void;
    onShowCurrentLocation: () => void;
    onWorkCompleted?: () => void;
}

const PermitMenu: React.FC<Props> = ({ isOpen, onClose, onReportProblem, onShowCurrentLocation, onWorkCompleted }) => {
    const [showWorkCompletedAlert, setshowWorkCompletedAlert] = useState(false);

    return (
        <IonPopover translucent={true} isOpen={isOpen} onDidDismiss={onClose}>
            <IonList lines="none">
                <IonItemGroup>
                    <IonItem>
                        <IonButton fill="clear" onClick={onShowCurrentLocation}>
                            Show current location
                        </IonButton>
                    </IonItem>
                </IonItemGroup>
                {onReportProblem && (
                    <IonItemGroup>
                        <IonItem>
                            <IonButton fill="clear" onClick={onReportProblem}>
                                Report Problem
                            </IonButton>
                        </IonItem>
                    </IonItemGroup>
                )}
                {onWorkCompleted && (
                    <IonItemGroup>
                        <IonItem>
                            <IonButton
                                id="work-completed"
                                fill="clear"
                                onClick={() => {
                                    setshowWorkCompletedAlert(true);
                                }}
                            >
                                Mark as work completed
                            </IonButton>
                            <IonAlert
                                isOpen={showWorkCompletedAlert}
                                header="Please confirm"
                                message={
                                    new IonicSafeString(
                                        `I confirm that the work to which this permit relates is now complete and that the Supervisor has made all personnel and materials are clear and that the work area has been left in a safe condition (i.e., physical / visual edge protection, warning notices, securely fixed marked covers, etc.).
                          <br/>
                          <br/>
                                     I am satisfied that the work area has been left in a safe condition and this permit is now expired.  `
                                    )
                                }
                                buttons={[
                                    {
                                        text: "Cancel",
                                        role: "cancel",
                                    },
                                    {
                                        text: "OK",
                                        role: "confirm",
                                        handler: onWorkCompleted,
                                    },
                                ]}
                                onDidDismiss={() => {
                                    setshowWorkCompletedAlert(false);
                                }}
                            ></IonAlert>
                        </IonItem>
                    </IonItemGroup>
                )}
            </IonList>
        </IonPopover>
    );
};

export default PermitMenu;
